import { FunctionComponent, useEffect, useState } from 'react';
import getConfig from 'next/config';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { Locales } from 'types/locale';
import { Routes } from 'types/routes';

import { Roles } from 'models/User';

import { select as selectLocale } from 'utils/locale';

import Logo from 'theme/images/logo-company.svg';

import LoginForm from 'components/modules/public/layout/forms/LoginForm';
import LayoutDefault from 'components/modules/public/layouts/Company';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutModalsJobLoginModal: FunctionComponent<Props> = ({ state, actions }) => {
    const [logged, setLogged]: [boolean, Function] = useState(false);

    const { publicRuntimeConfig } = getConfig();
    const router = useRouter();

    const translations = selectLocale({
        [Locales.Pl]: require('./locales/pl.json'),
    });

    const checkProfile = () => {
        if (!logged) return actions.profileGet();

        if (state.profile?.role !== Roles.Company) return;

        if (!state.profile.isActive) {
            return router.push(Routes.PublicActivationAccount);
        }

        if (state.profile.isActive || state.authToken || state.refreshToken) {
            return router.push({
                pathname: publicRuntimeConfig.COMPANY_PANEL_URL + Routes.CompanyAccount,
                query:  { refreshToken: state?.refreshToken || undefined },
            });
        }
    };

    useEffect(() => {
        checkProfile();
    }, [state.profile]);

    return (
        <StyledComponent className="public-layout-page-login-employer">
            <LayoutDefault>
                <Head>
                    <meta
                        name='robots'
                        content='noindex, nofollow'
                    />
                </Head>
                <header className="header">
                    <a href={Routes.PublicCompany}>
                        <img
                            className="logo"
                            src={Logo}
                            loading="lazy"
                        />
                    </a>
                    <h1>{translations?.title}</h1>
                    <p>{translations?.subTitle}</p>
                </header>

                <div className="header-mobile">
                    <a href={Routes.PublicHome}>
                        <img
                            className="logo"
                            src={Logo}
                            loading="lazy"
                        />
                    </a>
                </div>

                <div className="mobile-links">
                    <div className="links">
                        <span className="links-page current-page">
                            {translations?.mobileLinks?.currentPage}
                        </span>
                        <a
                            href={Routes.PublicRegisterCompany}
                            className="links-page link-register"
                        >
                            {translations?.mobileLinks?.registerPage}
                        </a>
                    </div>
                </div>

                <LoginForm
                    {...translations?.loginFormProps}
                    onSuccess={() => {
                        actions.profileGet();
                        setLogged(true);
                        checkProfile();
                    }}
                    roleType={Roles.Company}
                    isLoginPhone={false}
                />
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicLayoutModalsJobLoginModal;
